import { render, staticRenderFns } from "./ImportCandidate.vue?vue&type=template&id=6cb04098&"
import script from "./ImportCandidate.vue?vue&type=script&lang=js&"
export * from "./ImportCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports